import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from '@tanstack/react-router';
import SettingsSidebar from '../settings/SettingsSidebar';
import PageLoader from '../common/PageLoader';
import { AnimatePresence } from 'framer-motion';

const WorkspaceSettingsLayout = () => {
  const [isPageLoading, setIsPageLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsPageLoading(true);
    const timer = setTimeout(() => {
      setIsPageLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen w-full bg-[#FFFFFF] font-inter">
      <SettingsSidebar />
      <main className="flex-1 flex justify-center">
        <AnimatePresence>
          {isPageLoading && <PageLoader />}
        </AnimatePresence>
        <div className="w-full max-w-[1024px]">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default WorkspaceSettingsLayout;
